import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useCallback, useState } from '@wordpress/element';
import { createHigherOrderComponent, __experimentalUseFocusOutside as useFocusOutside } from '@wordpress/compose';
export default createHigherOrderComponent(function (WrappedComponent) {
  return function (props) {
    var _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        handleFocusOutside = _useState2[0],
        setHandleFocusOutside = _useState2[1];

    var bindFocusOutsideHandler = useCallback(function (node) {
      return setHandleFocusOutside(function () {
        return node !== null && node !== void 0 && node.handleFocusOutside ? node.handleFocusOutside.bind(node) : undefined;
      });
    }, []);
    return createElement("div", useFocusOutside(handleFocusOutside), createElement(WrappedComponent, _extends({
      ref: bindFocusOutsideHandler
    }, props)));
  };
}, 'withFocusOutside');
//# sourceMappingURL=index.js.map